export interface StudyCenterPageProps {
  studycenterPageId: string;
  category: {
    questionCategoryId: string;
    name: string;
  };
  exams: {
    examId: string
    score: string
  }[];
  videos: {
    videoId: string;
    score: string;
  }[];
  projectedPoints: number;
  group: {
    studycenterGroupId: number;
    name: string;
    icon?: string;
  }
}

export const PERCENTAGE = {
  TUTORIALS: 0.45,
  QUESTION_BANK: 0.20,
  PACKS: 0.35
};

export const MAX_SCORE = 5;

export enum CollectionType {
  Default = 'default',
  QuestionBank = 'question_bank',
  QuestionType = 'question_type',
}

export const getTotalScore = (list: any[], key= 'score')=> list.reduce((acc, curr) => acc + Number(curr[key]), 0);

export const getPageWithCalculations = (page: StudyCenterPageProps) => {
  const bankMaxPoints = Math.round(PERCENTAGE.QUESTION_BANK * page.projectedPoints);
  const tutorialsMaxPoints = Math.round(PERCENTAGE.TUTORIALS * page.projectedPoints);
  const packsMaxPoints = Math.round(PERCENTAGE.PACKS * page.projectedPoints);

  const bankTutorials = page.videos.filter((video: any) => video.collection === CollectionType.QuestionBank);
  const tutorials = page.videos.filter((video: any) => video.collection === CollectionType.QuestionType);
  const packs = page?.exams ?? [];

  const bankTotal = getTotalScore(bankTutorials) > 0
    ? Math.round((getTotalScore(bankTutorials) / (MAX_SCORE * bankTutorials.length)) * bankMaxPoints) : 0;
  const tutorialTotal = getTotalScore(tutorials) > 0
    ? Math.round((getTotalScore(tutorials) / (MAX_SCORE * tutorials.length)) * tutorialsMaxPoints) : 0;
  const packTotal = getTotalScore(packs) > 0
    ? Math.round((getTotalScore(packs) / (MAX_SCORE * packs.length)) * packsMaxPoints) : 0;

  const currentPoints = bankTotal + tutorialTotal + packTotal;

  return { ...page, currentPoints };
};
